export const COUNTRIES_LIST = [
  {
    name: "Canada",
    code: "CA",
    states: [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland and Labrador",
      "Nova Scotia",
      "Northwest Territories",
      "Nunavut",
      "Ontario",
      "Prince Edward Island",
      "Québec",
      "Saskatchewan",
      "Yukon",
    ],
  },
  {
    name: "United States",
    code: "US",
    states: [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District Of Columbia",
      "Federated States Of Micronesia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Marshall Islands",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Palau",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virgin Islands",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ],
  },
  {
    name: "Afghanistan",
    code: "AF",
  },
  {
    name: "Åland Islands",
    code: "AX",
  },
  {
    name: "Albania",
    code: "AL",
  },
  {
    name: "Algeria",
    code: "DZ",
  },
  {
    name: "American Samoa",
    code: "AS",
  },
  {
    name: "Andorra",
    code: "AD",
  },
  {
    name: "Angola",
    code: "AO",
  },
  {
    name: "Anguilla",
    code: "AI",
  },
  {
    name: "Antarctica",
    code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
  },
  {
    name: "Argentina",
    code: "AR",
  },
  {
    name: "Armenia",
    code: "AM",
  },
  {
    name: "Aruba",
    code: "AW",
  },
  {
    name: "Australia",
    code: "AU",
  },
  {
    name: "Austria",
    code: "AT",
  },
  {
    name: "Azerbaijan",
    code: "AZ",
  },
  {
    name: "Bahamas",
    code: "BS",
  },
  {
    name: "Bahrain",
    code: "BH",
  },
  {
    name: "Bangladesh",
    code: "BD",
  },
  {
    name: "Barbados",
    code: "BB",
  },
  {
    name: "Belarus",
    code: "BY",
  },
  {
    name: "Belgium",
    code: "BE",
  },
  {
    name: "Belize",
    code: "BZ",
  },
  {
    name: "Benin",
    code: "BJ",
  },
  {
    name: "Bermuda",
    code: "BM",
  },
  {
    name: "Bhutan",
    code: "BT",
  },
  {
    name: "Bolivia",
    code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BA",
  },
  {
    name: "Botswana",
    code: "BW",
  },
  {
    name: "Bouvet Island",
    code: "BV",
  },
  {
    name: "Brazil",
    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
  },
  {
    name: "Brunei Darussalam",
    code: "BN",
  },
  {
    name: "Bulgaria",
    code: "BG",
  },
  {
    name: "Burkina Faso",
    code: "BF",
  },
  {
    name: "Burundi",
    code: "BI",
  },
  {
    name: "Cambodia",
    code: "KH",
  },
  {
    name: "Cameroon",
    code: "CM",
  },
  {
    name: "Cape Verde",
    code: "CV",
  },
  {
    name: "Cayman Islands",
    code: "KY",
  },
  {
    name: "Central African Republic",
    code: "CF",
  },
  {
    name: "Chad",
    code: "TD",
  },
  {
    name: "Chile",
    code: "CL",
  },
  {
    name: "China",
    code: "CN",
  },
  {
    name: "Christmas Island",
    code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
  },
  {
    name: "Colombia",
    code: "CO",
  },
  {
    name: "Comoros",
    code: "KM",
  },
  {
    name: "Republic of the Congo",
    code: "CG",
  },
  {
    name: "Democratic Republic of the Congo",
    code: "CD",
  },
  {
    name: "Cook Islands",
    code: "CK",
  },
  {
    name: "Costa Rica",
    code: "CR",
  },
  {
    name: "Côte d'Ivoire",
    code: "CI",
  },
  {
    name: "Croatia",
    code: "HR",
  },
  {
    name: "Cuba",
    code: "CU",
  },
  {
    name: "Cyprus",
    code: "CY",
  },
  {
    name: "Czech Republic",
    code: "CZ",
  },
  {
    name: "Denmark",
    code: "DK",
  },
  {
    name: "Djibouti",
    code: "DJ",
  },
  {
    name: "Dominica",
    code: "DM",
  },
  {
    name: "Dominican Republic",
    code: "DO",
  },
  {
    name: "Ecuador",
    code: "EC",
  },
  {
    name: "Egypt",
    code: "EG",
  },
  {
    name: "El Salvador",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
  },
  {
    name: "Eritrea",
    code: "ER",
  },
  {
    name: "Estonia",
    code: "EE",
  },
  {
    name: "Ethiopia",
    code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    code: "FK",
  },
  {
    name: "Faroe Islands",
    code: "FO",
  },
  {
    name: "Fiji",
    code: "FJ",
  },
  {
    name: "Finland",
    code: "FI",
  },
  {
    name: "France",
    code: "FR",
  },
  {
    name: "French Guiana",
    code: "GF",
  },
  {
    name: "French Polynesia",
    code: "PF",
  },
  {
    name: "French Southern Territories",
    code: "TF",
  },
  {
    name: "Gabon",
    code: "GA",
  },
  {
    name: "Gambia",
    code: "GM",
  },
  {
    name: "Georgia",
    code: "GE",
  },
  {
    name: "Germany",
    code: "DE",
  },
  {
    name: "Ghana",
    code: "GH",
  },
  {
    name: "Gibraltar",
    code: "GI",
  },
  {
    name: "Greece",
    code: "GR",
  },
  {
    name: "Greenland",
    code: "GL",
  },
  {
    name: "Grenada",
    code: "GD",
  },
  {
    name: "Guadeloupe",
    code: "GP",
  },
  {
    name: "Guam",
    code: "GU",
  },
  {
    name: "Guatemala",
    code: "GT",
  },
  {
    name: "Guernsey",
    code: "GG",
  },
  {
    name: "Guinea",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
  },
  {
    name: "Guyana",
    code: "GY",
  },
  {
    name: "Haiti",
    code: "HT",
  },
  {
    name: "Heard Island and Mcdonald Islands",
    code: "HM",
  },
  {
    name: "Holy See (Vatican City State)",
    code: "VA",
  },
  {
    name: "Honduras",
    code: "HN",
  },
  {
    name: "Hong Kong",
    code: "HK",
  },
  {
    name: "Hungary",
    code: "HU",
  },
  {
    name: "Iceland",
    code: "IS",
  },
  {
    name: "India",
    code: "IN",
  },
  {
    name: "Indonesia",
    code: "ID",
  },
  {
    name: "Iran",
    code: "IR",
  },
  {
    name: "Iraq",
    code: "IQ",
  },
  {
    name: "Ireland",
    code: "IE",
  },
  {
    name: "Isle of Man",
    code: "IM",
  },
  {
    name: "Israel",
    code: "IL",
  },
  {
    name: "Italy",
    code: "IT",
  },
  {
    name: "Jamaica",
    code: "JM",
  },
  {
    name: "Japan",
    code: "JP",
  },
  {
    name: "Jersey",
    code: "JE",
  },
  {
    name: "Jordan",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    code: "KZ",
  },
  {
    name: "Kenya",
    code: "KE",
  },
  {
    name: "Kiribati",
    code: "KI",
  },
  {
    name: "North Korea",
    code: "KP",
  },
  {
    name: "South Korea",
    code: "KR",
  },
  {
    name: "Kuwait",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
  },
  {
    name: "Laos",
    code: "LA",
  },
  {
    name: "Latvia",
    code: "LV",
  },
  {
    name: "Lebanon",
    code: "LB",
  },
  {
    name: "Lesotho",
    code: "LS",
  },
  {
    name: "Liberia",
    code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    code: "LI",
  },
  {
    name: "Lithuania",
    code: "LT",
  },
  {
    name: "Luxembourg",
    code: "LU",
  },
  {
    name: "Macao",
    code: "MO",
  },
  {
    name: "Macedonia",
    code: "MK",
  },
  {
    name: "Madagascar",
    code: "MG",
  },
  {
    name: "Malawi",
    code: "MW",
  },
  {
    name: "Malaysia",
    code: "MY",
  },
  {
    name: "Maldives",
    code: "MV",
  },
  {
    name: "Mali",
    code: "ML",
  },
  {
    name: "Malta",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    code: "MH",
  },
  {
    name: "Martinique",
    code: "MQ",
  },
  {
    name: "Mauritania",
    code: "MR",
  },
  {
    name: "Mauritius",
    code: "MU",
  },
  {
    name: "Mayotte",
    code: "YT",
  },
  {
    name: "Mexico",
    code: "MX",
  },
  {
    name: "Micronesia",
    code: "FM",
  },
  {
    name: "Moldova",
    code: "MD",
  },
  {
    name: "Monaco",
    code: "MC",
  },
  {
    name: "Mongolia",
    code: "MN",
  },
  {
    name: "Montserrat",
    code: "MS",
  },
  {
    name: "Morocco",
    code: "MA",
  },
  {
    name: "Mozambique",
    code: "MZ",
  },
  {
    name: "Myanmar",
    code: "MM",
  },
  {
    name: "Namibia",
    code: "NA",
  },
  {
    name: "Nauru",
    code: "NR",
  },
  {
    name: "Nepal",
    code: "NP",
  },
  {
    name: "Netherlands",
    code: "NL",
  },
  {
    name: "Netherlands Antilles",
    code: "AN",
  },
  {
    name: "New Caledonia",
    code: "NC",
  },
  {
    name: "New Zealand",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    code: "NI",
  },
  {
    name: "Niger",
    code: "NE",
  },
  {
    name: "Nigeria",
    code: "NG",
  },
  {
    name: "Niue",
    code: "NU",
  },
  {
    name: "Norfolk Island",
    code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
  },
  {
    name: "Norway",
    code: "NO",
  },
  {
    name: "Oman",
    code: "OM",
  },
  {
    name: "Pakistan",
    code: "PK",
  },
  {
    name: "Palau",
    code: "PW",
  },
  {
    name: "Palestine",
    code: "PS",
  },
  {
    name: "Panama",
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    code: "PG",
  },
  {
    name: "Paraguay",
    code: "PY",
  },
  {
    name: "Peru",
    code: "PE",
  },
  {
    name: "Philippines",
    code: "PH",
  },
  {
    name: "Pitcairn",
    code: "PN",
  },
  {
    name: "Poland",
    code: "PL",
  },
  {
    name: "Portugal",
    code: "PT",
  },
  {
    name: "Puerto Rico",
    code: "PR",
  },
  {
    name: "Qatar",
    code: "QA",
  },
  {
    name: "Reunion",
    code: "RE",
  },
  {
    name: "Romania",
    code: "RO",
  },
  {
    name: "Russian Federation",
    code: "RU",
  },
  {
    name: "RWANDA",
    code: "RW",
  },
  {
    name: "Saint Helena",
    code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    code: "LC",
  },
  {
    name: "Saint Pierre and Miquelon",
    code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    code: "VC",
  },
  {
    name: "Samoa",
    code: "WS",
  },
  {
    name: "San Marino",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    code: "SA",
  },
  {
    name: "Senegal",
    code: "SN",
  },
  {
    name: "Serbia and Montenegro",
    code: "CS",
  },
  {
    name: "Seychelles",
    code: "SC",
  },
  {
    name: "Sierra Leone",
    code: "SL",
  },
  {
    name: "Singapore",
    code: "SG",
  },
  {
    name: "Slovakia",
    code: "SK",
  },
  {
    name: "Slovenia",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    code: "SB",
  },
  {
    name: "Somalia",
    code: "SO",
  },
  {
    name: "South Africa",
    code: "ZA",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    code: "GS",
  },
  {
    name: "Spain",
    code: "ES",
  },
  {
    name: "Sri Lanka",
    code: "LK",
  },
  {
    name: "Sudan",
    code: "SD",
  },
  {
    name: "Suriname",
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    code: "SJ",
  },
  {
    name: "Swaziland",
    code: "SZ",
  },
  {
    name: "Sweden",
    code: "SE",
  },
  {
    name: "Switzerland",
    code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    code: "SY",
  },
  {
    name: "Taiwan",
    code: "TW",
  },
  {
    name: "Tajikistan",
    code: "TJ",
  },
  {
    name: "Tanzania",
    code: "TZ",
  },
  {
    name: "Thailand",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    code: "TL",
  },
  {
    name: "Togo",
    code: "TG",
  },
  {
    name: "Tokelau",
    code: "TK",
  },
  {
    name: "Tonga",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    code: "TT",
  },
  {
    name: "Tunisia",
    code: "TN",
  },
  {
    name: "Turkey",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    code: "TC",
  },
  {
    name: "Tuvalu",
    code: "TV",
  },
  {
    name: "Uganda",
    code: "UG",
  },
  {
    name: "Ukraine",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
  },
  {
    name: "United Kingdom",
    code: "GB",
  },
  {
    name: "United States Minor Outlying Islands",
    code: "UM",
  },
  {
    name: "Uruguay",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    code: "VU",
  },
  {
    name: "Venezuela",
    code: "VE",
  },
  {
    name: "Viet Nam",
    code: "VN",
  },
  {
    name: "Virgin Islands, British",
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    code: "VI",
  },
  {
    name: "Wallis and Futuna",
    code: "WF",
  },
  {
    name: "Western Sahara",
    code: "EH",
  },
  {
    name: "Yemen",
    code: "YE",
  },
  {
    name: "Zambia",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    code: "ZW",
  },
];


export const LANGUAGES_LIST = [
  { value: "af", text: "Afrikaans" },
  { value: "sq", text: "Albanian" },
  { value: "an", text: "Aragonese" },
  { value: "ar", text: "Arabic (Standard)" },
  { value: "ar-dz", text: "Arabic (Algeria)" },
  { value: "ar-bh", text: "Arabic (Bahrain)" },
  { value: "ar-eg", text: "Arabic (Egypt)" },
  { value: "ar-iq", text: "Arabic (Iraq)" },
  { value: "ar-jo", text: "Arabic (Jordan)" },
  { value: "ar-kw", text: "Arabic (Kuwait)" },
  { value: "ar-lb", text: "Arabic (Lebanon)" },
  { value: "ar-ly", text: "Arabic (Libya)" },
  { value: "ar-ma", text: "Arabic (Morocco)" },
  { value: "ar-om", text: "Arabic (Oman)" },
  { value: "ar-qa", text: "Arabic (Qatar)" },
  { value: "ar-sa", text: "Arabic (Saudi Arabia)" },
  { value: "ar-sy", text: "Arabic (Syria)" },
  { value: "ar-tn", text: "Arabic (Tunisia)" },
  { value: "ar-ae", text: "Arabic (U.A.E.)" },
  { value: "ar-ye", text: "Arabic (Yemen)" },
  { value: "hy", text: "Armenian" },
  { value: "as", text: "Assamese" },
  { value: "ast", text: "Asturian" },
  { value: "az", text: "Azerbaijani" },
  { value: "eu", text: "Basque" },
  { value: "bg", text: "Bulgarian" },
  { value: "be", text: "Belarusian" },
  { value: "bn", text: "Bengali" },
  { value: "bs", text: "Bosnian" },
  { value: "br", text: "Breton" },
  { value: "my", text: "Burmese" },
  { value: "ca", text: "Catalan" },
  { value: "ch", text: "Chamorro" },
  { value: "ce", text: "Chechen" },
  { value: "zh", text: "Chinese" },
  { value: "zh-hk", text: "Chinese (Hong Kong)" },
  { value: "zh-cn", text: "Chinese (PRC)" },
  { value: "zh-sg", text: "Chinese (Singapore)" },
  { value: "zh-tw", text: "Chinese (Taiwan)" },
  { value: "cv", text: "Chuvash" },
  { value: "co", text: "Corsican" },
  { value: "cr", text: "Cree" },
  { value: "hr", text: "Croatian" },
  { value: "cs", text: "Czech" },
  { value: "da", text: "Danish" },
  { value: "nl", text: "Dutch (Standard)" },
  { value: "nl-be", text: "Dutch (Belgian)" },
  { value: "en", text: "English" },
  { value: "en-au", text: "English (Australia)" },
  { value: "en-bz", text: "English (Belize)" },
  { value: "en-ca", text: "English (Canada)" },
  { value: "en-ie", text: "English (Ireland)" },
  { value: "en-jm", text: "English (Jamaica)" },
  { value: "en-nz", text: "English (New Zealand)" },
  { value: "en-ph", text: "English (Philippines)" },
  { value: "en-za", text: "English (South Africa)" },
  { value: "en-tt", text: "English (Trinidad & Tobago)" },
  { value: "en-gb", text: "English (United Kingdom)" },
  { value: "en-us", text: "English (United States)" },
  { value: "en-zw", text: "English (Zimbabwe)" },
  { value: "eo", text: "Esperanto" },
  { value: "et", text: "Estonian" },
  { value: "fo", text: "Faeroese" },
  { value: "fa", text: "Farsi" },
  { value: "fj", text: "Fijian" },
  { value: "fi", text: "Finnish" },
  { value: "fr", text: "French (Standard)" },
  { value: "fr-be", text: "French (Belgium)" },
  { value: "fr-ca", text: "French (Canada)" },
  { value: "fr-fr", text: "French (France)" },
  { value: "fr-lu", text: "French (Luxembourg)" },
  { value: "fr-mc", text: "French (Monaco)" },
  { value: "fr-ch", text: "French (Switzerland)" },
  { value: "fy", text: "Frisian" },
  { value: "fur", text: "Friulian" },
  { value: "gd", text: "Gaelic (Scots)" },
  { value: "gd-ie", text: "Gaelic (Irish)" },
  { value: "gl", text: "Galacian" },
  { value: "ka", text: "Georgian" },
  { value: "de", text: "German (Standard)" },
  { value: "de-at", text: "German (Austria)" },
  { value: "de-de", text: "German (Germany)" },
  { value: "de-li", text: "German (Liechtenstein)" },
  { value: "de-lu", text: "German (Luxembourg)" },
  { value: "de-ch", text: "German (Switzerland)" },
  { value: "el", text: "Greek" },
  { value: "gu", text: "Gujurati" },
  { value: "ht", text: "Haitian" },
  { value: "he", text: "Hebrew" },
  { value: "hi", text: "Hindi" },
  { value: "hu", text: "Hungarian" },
  { value: "is", text: "Icelandic" },
  { value: "id", text: "Indonesian" },
  { value: "iu", text: "Inuktitut" },
  { value: "ga", text: "Irish" },
  { value: "it", text: "Italian (Standard)" },
  { value: "it-ch", text: "Italian (Switzerland)" },
  { value: "ja", text: "Japanese" },
  { value: "kn", text: "Kannada" },
  { value: "ks", text: "Kashmiri" },
  { value: "kk", text: "Kazakh" },
  { value: "km", text: "Khmer" },
  { value: "tlh", text: "Klingon" },
  { value: "ko", text: "Korean" },
  { value: "ko-kp", text: "Korean (North Korea)" },
  { value: "ko-kr", text: "Korean (South Korea)" },
  { value: "la", text: "Latin" },
  { value: "lv", text: "Latvian" },
  { value: "lt", text: "Lithuanian" },
  { value: "lb", text: "Luxembourgish" },
  { value: "mk", text: "FYRO Macedonian" },
  { value: "ms", text: "Malay" },
  { value: "ml", text: "Malayalam" },
  { value: "mt", text: "Maltese" },
  { value: "mi", text: "Maori" },
  { value: "mr", text: "Marathi" },
  { value: "mo", text: "Moldavian" },
  { value: "nv", text: "Navajo" },
  { value: "ng", text: "Ndonga" },
  { value: "ne", text: "Nepali" },
  { value: "no", text: "Norwegian" },
  { value: "nb", text: "Norwegian (Bokmal)" },
  { value: "nn", text: "Norwegian (Nynorsk)" },
  { value: "oc", text: "Occitan" },
  { value: "or", text: "Oriya" },
  { value: "om", text: "Oromo" },
  { value: "fa-ir", text: "Persian/Iran" },
  { value: "pl", text: "Polish" },
  { value: "pt", text: "Portuguese" },
  { value: "pt-br", text: "Portuguese (Brazil)" },
  { value: "pa", text: "Punjabi" },
  { value: "pa-in", text: "Punjabi (India)" },
  { value: "pa-pk", text: "Punjabi (Pakistan)" },
  { value: "qu", text: "Quechua" },
  { value: "rm", text: "Rhaeto-Romanic" },
  { value: "ro", text: "Romanian" },
  { value: "ro-mo", text: "Romanian (Moldavia)" },
  { value: "ru", text: "Russian" },
  { value: "ru-mo", text: "Russian (Moldavia)" },
  { value: "sz", text: "Sami (Lappish)" },
  { value: "sg", text: "Sango" },
  { value: "sa", text: "Sanskrit" },
  { value: "sc", text: "Sardinian" },
  { value: "sd", text: "Sindhi" },
  { value: "si", text: "Singhalese" },
  { value: "sr", text: "Serbian" },
  { value: "sk", text: "Slovak" },
  { value: "sl", text: "Slovenian" },
  { value: "so", text: "Somani" },
  { value: "sb", text: "Sorbian" },
  { value: "es", text: "Spanish" },
  { value: "es-ar", text: "Spanish (Argentina)" },
  { value: "es-bo", text: "Spanish (Bolivia)" },
  { value: "es-cl", text: "Spanish (Chile)" },
  { value: "es-co", text: "Spanish (Colombia)" },
  { value: "es-cr", text: "Spanish (Costa Rica)" },
  { value: "es-do", text: "Spanish (Dominican Republic)" },
  { value: "es-ec", text: "Spanish (Ecuador)" },
  { value: "es-sv", text: "Spanish (El Salvador)" },
  { value: "es-gt", text: "Spanish (Guatemala)" },
  { value: "es-hn", text: "Spanish (Honduras)" },
  { value: "es-mx", text: "Spanish (Mexico)" },
  { value: "es-ni", text: "Spanish (Nicaragua)" },
  { value: "es-pa", text: "Spanish (Panama)" },
  { value: "es-py", text: "Spanish (Paraguay)" },
  { value: "es-pe", text: "Spanish (Peru)" },
  { value: "es-pr", text: "Spanish (Puerto Rico)" },
  { value: "es-es", text: "Spanish (Spain)" },
  { value: "es-uy", text: "Spanish (Uruguay)" },
  { value: "es-ve", text: "Spanish (Venezuela)" },
  { value: "sx", text: "Sutu" },
  { value: "sw", text: "Swahili" },
  { value: "sv", text: "Swedish" },
  { value: "sv-fi", text: "Swedish (Finland)" },
  { value: "sv-sv", text: "Swedish (Sweden)" },
  { value: "ta", text: "Tamil" },
  { value: "tt", text: "Tatar" },
  { value: "te", text: "Teluga" },
  { value: "th", text: "Thai" },
  { value: "tig", text: "Tigre" },
  { value: "ts", text: "Tsonga" },
  { value: "tn", text: "Tswana" },
  { value: "tr", text: "Turkish" },
  { value: "tk", text: "Turkmen" },
  { value: "uk", text: "Ukrainian" },
  { value: "hsb", text: "Upper Sorbian" },
  { value: "ur", text: "Urdu" },
  { value: "ve", text: "Venda" },
  { value: "vi", text: "Viettextse" },
  { value: "vo", text: "Volapuk" },
  { value: "wa", text: "Walloon" },
  { value: "cy", text: "Welsh" },
  { value: "xh", text: "Xhosa" },
  { value: "ji", text: "Yiddish" },
  { value: "zu", text: "Zulu" },
];